// extracted by mini-css-extract-plugin
export default {"textInputContainer":"styles_textInputContainer__RfWxk","label":"styles_label__lySrz"};